import { gql } from 'react-apollo';
import {
    SET_REFUND_STATUS_START,
    SET_REFUND_STATUS_SUCCESS,
    SET_REFUND_STATUS_ERROR
} from '../constants';
import showToaster from '../helpers/showToaster';

export function updateRefundStatus(id, isRefundHold) {
    return async (dispatch, getState, { client }) => {
        dispatch({
            type: SET_REFUND_STATUS_START
        });
        try {
            let mutation = gql`
            mutation updateRefundStatus ($id: Int!, $isRefundHold: Boolean!){
                updateRefundStatus(id: $id, isRefundHold: $isRefundHold){
                    status
                    errorMessage
                }
              }
            `;

            const { data } = await client.mutate({
                mutation,
                variables: {
                    id,
                    isRefundHold
                }
            });

            if (data?.updateRefundStatus?.status == '200') {
                dispatch({
                    type: SET_REFUND_STATUS_SUCCESS
                });
                showToaster({ messageId: 'holdRefundSuccess', toasterType: 'success' })
                return true;
            } else {
                dispatch({
                    type: SET_REFUND_STATUS_ERROR
                });
                showToaster({ messageId: 'holdRefundError', toasterType: 'error' })
            }
        } catch (error) {
            dispatch({
                type: SET_REFUND_STATUS_ERROR
            });
            showToaster({ messageId: 'holdRefundError', toasterType: 'error' })
        }
    }
}